class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');   
    cloneCart();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');  
    cloneCart();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);    
      cloneCart();
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();         
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
         id: 'header-total'
      },
      {
        id: 'cart-icon-bubble'
      }
      
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },      
      {
        id: 'header-total',
        section: 'header-total',
        selector: '.total-sub'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];    
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
function cloneCart() {
var cardTotalDiv = document.getElementById('cartSubTotal');
var cartNav = document.getElementById('cartNav');
cartNav.innerHTML = '';
clone = cardTotalDiv.cloneNode(true);
clone.id = "sticky_headerTotal";
cartNav.appendChild(clone);  
}




document.addEventListener('change', function (event) {
    // Update order note
    if (event.target.id === 'CartDrawer-Note') {
        var note = event.target.value;
        updateCart({ note: note }, 'Order note updated');
    }

    // Update discount code
    if (event.target.id === 'CartDrawer-DiscountCode') {
        var discountCode = event.target.value;
        if (discountCode) {
            applyDiscountCode(discountCode);
        } else {
            removeDiscountCode();
        }
    }
});

// Function to update the cart with note or discount
function updateCart(data, successMessage) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
            var cart = JSON.parse(xhr.responseText);
            console.log(successMessage, cart);
        } else {
            console.error('Error updating cart:', xhr.statusText);
        }
    };

    xhr.onerror = function () {
        console.error('Error updating cart:', xhr.statusText);
    };

    xhr.send(JSON.stringify(data));
}

// Function to apply a discount code
function applyDiscountCode(discountCode) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
            var cart = JSON.parse(xhr.responseText);
            console.log('Discount code applied:', cart.discount_code);
        } else {
            console.error('Error applying discount code:', xhr.statusText);
        }
    };

    xhr.onerror = function () {
        console.error('Error applying discount code:', xhr.statusText);
    };

    xhr.send(JSON.stringify({ attributes: { _discount_code: discountCode } }));
}

// Function to remove the discount code
function removeDiscountCode() {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
            var cart = JSON.parse(xhr.responseText);
            console.log('Discount code removed:', cart.discount_code);
        } else {
            console.error('Error removing discount code:', xhr.statusText);
        }
    };

    xhr.onerror = function () {
        console.error('Error removing discount code:', xhr.statusText);
    };

    xhr.send(JSON.stringify({ attributes: { _discount_code: '' } }));
}
